import { ApplicantStatus, HiringStatus } from '@/Models/CandidateOverview';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

export function applicantStatusToString(applicantStatus: ApplicantStatus): string {
    return UIStrings[applicantStatus];
}

export function hiringStatusToString(hiringStatus: HiringStatus | null): string {
    if (hiringStatus) {
        return UIStrings[hiringStatus];
    }

    return UIStrings.EmptyHiringStatus;
}

export const mainTestTypesRenderingOrder: Array<TestTypes> = [
    TestTypes.Personality,
    TestTypes.Aptitude,
    TestTypes.Skills,
    TestTypes.EmotionalIntelligence,
];
